import React from "react";
import { Button } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router";
import compose from "recompose/compose";
import PropTypes from "prop-types";

const styles = {
  button: {
    margin: 8
  },
  contentHeaderMenuLink: {
    textDecoration: "none",
    color: "white",
    padding: 8
  },
  content: {
    padding: "16px"
  }
};

function EditWarrantyRegistrationButton(props) {
  const { registration, history } = props;
  //console.log("props");
  //console.log(props);

  function handleEditUser(id) {
    //console.log(id);
    ///const history = id.history;
    history.push(`/admin-warranty-registrations/${id}/edit`);
    //this.props.history.push(`/admin-my-dealers/dealers/${id.profile_id}/edit`);
  }

  return (
    <div>
      <Button variant="contained" color="secondary" style={styles.button} onClick={() => handleEditUser(registration.id)}>
        Edit Warranty Registration
      </Button>
    </div>
  );
}

EditWarrantyRegistrationButton.propTypes = {
  classes: PropTypes.object.isRequired
};

export default compose(withRouter, withStyles(styles))(EditWarrantyRegistrationButton);
